import { render } from "./TmpPatientsFilters.vue?vue&type=template&id=2d282118&scoped=true"
import script from "./TmpPatientsFilters.vue?vue&type=script&lang=js"
export * from "./TmpPatientsFilters.vue?vue&type=script&lang=js"

import "./TmpPatientsFilters.vue?vue&type=style&index=0&id=2d282118&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d282118"]])

export default __exports__